import * as React from 'react';

function IconRepeat(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M2.867 8.247v-.674A3.377 3.377 0 016.24 4.2h5.06l-.373.373a.801.801 0 001.133 1.134l1.74-1.74a.82.82 0 00.233-.567.82.82 0 00-.233-.567l-1.74-1.74a.8.8 0 10-1.133 1.134l.373.373H6.24a4.982 4.982 0 00-4.973 4.973v.674c0 .44.36.8.8.8.44 0 .8-.354.8-.8zm11.066-1.294c-.44 0-.8.36-.8.8v.674A3.377 3.377 0 019.76 11.8H4.7l.373-.373a.801.801 0 10-1.133-1.134l-1.74 1.74a.78.78 0 00-.233.567.82.82 0 00.233.567l1.74 1.74a.803.803 0 001.133-1.134L4.7 13.4h5.06a4.982 4.982 0 004.973-4.973v-.674c0-.446-.36-.8-.8-.8z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoIconRepeat = React.memo(IconRepeat);
export default MemoIconRepeat;
